import React, {PropsWithChildren} from 'react';
import {EdgeLabelRenderer} from 'reactflow';

interface EdgeLabelProps {}

const defaultFunc = function DefaultEdgeLabelRenderer(props: PropsWithChildren<EdgeLabelProps>): JSX.Element {
  return (
    <div>
      <EdgeLabelRenderer>{props.children}</EdgeLabelRenderer>
    </div>
  );
};

const mockFunc = function MockEdgeLabelRenderer(props: PropsWithChildren<EdgeLabelProps>): JSX.Element {
  return (
    <div className="mock-edge-label-renderer">
      <svg>{props.children}</svg>
    </div>
  );
};

/**
 * Allow reassigning ProcedureEdgeLabelRenderer in test to MockEdgeLabelRenderer by using mock().
 * Restored after each test
 */
let ProcedureEdgeLabelRenderer = defaultFunc; // eslint-disable-line import-x/no-mutable-exports

// eslint-disable-next-line no-restricted-exports
export {ProcedureEdgeLabelRenderer as default};

export function mock(): void {
  ProcedureEdgeLabelRenderer = mockFunc;
}

export function restore(): void {
  ProcedureEdgeLabelRenderer = defaultFunc;
}
